import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {ATTORNEY} from '../../../constants/MicroServiceConstants';
import {STATE} from '../../../constants/Lookup';

const initialData = {
  customerAttorneyData: {},
  dropDownData: {},
  customerAttorneyStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'customerAttorney',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getCustomerAttorneyInfo: (state, action) => {
      state.customerAttorneyData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postCustomerAttorneyInfo: (state, action) => {
      state.customerAttorneyStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response ? action.payload.response : null;
    },

    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  getCustomerAttorneyInfo,
  fetchDropDownData,
  postCustomerAttorneyInfo,
  fetchStart,
  fetchError,
} = slice.actions;

export const fetchCustomerAttorney = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [STATE],
      }),
      httpGet(`${ATTORNEY}/find/custmatrny/${accountNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const attorneyData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (attorneyData && attorneyData.status && attorneyData.status === 200) {
          dispatch(getCustomerAttorneyInfo(attorneyData.response));
        } else {
          dispatch(fetchError(attorneyData?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postCustomerAttorney = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${ATTORNEY}/save/custmatrny`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCustomerAttorneyInfo(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
